import { useAccountLimitsContext } from "../../context/account-limit-context";
import { listenEnabled } from "../../generic/server/supabase-account-service";

/** Straight into a new survey with Listen; to the Listen landing page, without it. */
export const useCreateSurveyHref = (): string => {
  const { listen_entitlement } = useAccountLimitsContext();

  return listenEnabled(listen_entitlement) ? "/listen/survey/new" : "/listen";
};
